import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { ArrowRight, CircleCheck, Cpu, ShieldCheck, Zap } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ValoriEVisione() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll();
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll();
  const values = [{
    title: "Trasparenza.",
    description: "Nessun passaggio intermedio, nessun livello di account management. La comunicazione è diretta, le decisioni sono rapide e le attività operative sono gestite senza filtri. Questo garantisce chiarezza, tempi di risposta ridotti e piena visibilità sugli interventi",
    icon: <ShieldCheck className="w-6 h-6 text-primary" />
  }, {
    title: "Dedizione.",
    description: "Come consulente indipendente, ogni incarico rappresenta una responsabilità diretta. L’obiettivo è costruire un rapporto di fiducia nel tempo, offrendo continuità operativa, attenzione alle esigenze reali dell’azienda e supporto tecnico concreto.",
    icon: <Zap className="w-6 h-6 text-primary" />
  }, {
    title: "Competenza.",
    description: "Oltre 10 anni di esperienza nella gestione di infrastrutture IT, sistemi operativi e tecnologie operative. Le soluzioni proposte sono progettate per essere affidabili, scalabili e realmente applicabili alla realtà operativa delle aziende.",
    icon: <Cpu className="w-6 h-6 text-primary" />
  }];
  return <section id="valori-e-visione" className="dark bg-background text-foreground py-24 relative overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_top_right,_var(--primary)_0%,_transparent_25%)] opacity-10"></div>
        <div className="absolute bottom-0 right-0 w-full h-full bg-[radial-gradient(circle_at_bottom_left,_var(--secondary)_0%,_transparent_25%)] opacity-10"></div>
        <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-5 mix-blend-overlay"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        {}
        <div ref={headerRef} className={`flex flex-col gap-2 mb-20 transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <h2 className="font-sans font-bold text-6xl md:text-8xl lg:text-9xl tracking-tighter leading-[0.9]">
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-foreground to-foreground/70 hover:to-primary transition-colors duration-500">
              Trasparenza.
            </span>
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-foreground/90 to-foreground/60 hover:to-primary transition-colors duration-500">
              Dedizione.
            </span>
            <span className="block text-primary">Competenza.</span>
          </h2>
        </div>

        <Separator className="mb-16 bg-border/30" />

        {}
        <div ref={contentRef} className={`grid grid-cols-1 md:grid-cols-3 gap-12 lg:gap-16 transition-all duration-1000 delay-300 ease-out ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          {values.map((item, i) => <div key={i} data-index={i} className="group flex flex-col gap-6">
              <div className="flex items-center gap-4">
                <div className="p-3 rounded-lg bg-primary/10 border border-primary/20 group-hover:bg-primary/20 transition-colors duration-300">
                  {item.icon}
                </div>
                <h3 className="text-2xl font-semibold tracking-tight text-foreground group-hover:text-primary transition-colors duration-300">
                  {item.title}
                </h3>
              </div>
              
              <p className="text-muted-foreground leading-relaxed text-lg">
                {item.description}
              </p>

              <div className="mt-auto pt-4">
                <div className="h-1 w-12 bg-primary/30 group-hover:w-full transition-all duration-500 ease-out rounded-full"></div>
              </div>
            </div>)}
        </div>

        {}
        <div className="mt-24 flex flex-col md:flex-row items-start md:items-center justify-between gap-8 p-8 rounded-2xl bg-secondary/20 border border-border/50 backdrop-blur-sm">
          <div className="max-w-2xl">
            <h4 className="text-xl font-semibold text-foreground mb-2">
              Perché scegliere un consulente indipendente?
            </h4>
            <p className="text-muted-foreground">
              Elimina i costi di struttura e ottieni un partner tecnico focalizzato esclusivamente sui tuoi obiettivi di business.
            </p>
          </div>
          <div className="flex flex-wrap gap-4 shrink-0">
            <Button asChild size="lg" className="text-base font-medium">
              <Link to="/ContactsPage">
                Parla con un esperto
                <ArrowRight className="ml-2 w-4 h-4" />
              </Link>
            </Button>
            <Button asChild variant="outline" size="lg" className="text-base font-medium border-primary/20 hover:bg-primary/10 hover:text-primary">
              <Link to="/ExperiencePage">
                Scopri l'esperienza
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}